<template>
  <card>
    <template #header>
      <h2 class="font-medium text-blue dark:text-white">
        <slot/>
      </h2>
    </template>

    <template #body>
      <div :id="id" class="mt-3 pr-3"/>
    </template>
  </card>
</template>

<script setup>
import Card from "@/components/cards/Card.vue"
import Highcharts from "@/highcharts"
import { computed, onMounted } from "vue"

import colors from "@/colors"
const props = defineProps({
  id: { type: String, required: true },
  school: { type: Object, required: true },
  data: { type: Object, required: true },
})

const data = computed(() => Object.values(props.school.first_first_time_bar_pass_rates))

onMounted(() => {
  const locationSeries = []

  Object.keys(props.data).forEach((key) => {
    locationSeries.push({
      name: key,
      data: props.data[key],
      marker: { symbol: "circle" },
      states: { hover: { enabled: true, lineWidth: .01 } },
      lineWidth: 0,
      type: "line",
    })
  })

  const options = {
    chart: {
      height: 365,
    },
    legend: {
      enabled: false,
    },
    title: {
      text: "",
    },
    xAxis: {
      title: {
        text: "Bar exam year",
      },
      categories: data.value.map((item) => item.year),
    },
    yAxis: {
      min: 0,
      max: 100,
      labels: { format: "{value}%" },
      title: { text: "First-time bar pass rate" },
      allowDecimals: false,
    },
    tooltip: {
      crosshairs: true,
      shared: true,
      headerFormat: '<span style="font-size: 16px;font-weight:600;">{point.key}</span><br/>',
      pointFormatter() {
        return `<br/><div style="font-size:14px;"><span style="color:${this.color}">●</span> ${this.series.name}: ${Math.round(this.y * 100) / 100}%</div>`
      },
    },
    series: [
      {
        type: "spline",
        name: "Overall pass rate",
        data: data.value.map((item) => item.rate),
        color: colors.green[400],
      },
      ...locationSeries,
    ],
  }

  new Highcharts.chart(props.id, options)
})
</script>
